module.exports = __webpack_public_path__ + "static/media/flip-keys.af8ebd2f.svg";